import {
  Amwins_Orbits_Contracts_Models_Distribution_DistributionSubmissionRequest,
  Amwins_Orbits_Contracts_Models_Distribution_CreateSubmissionResponse,
  Any,
  DistributionUnauthorizedUser,
  Amwins_Orbits_Contracts_MessageContracts_Quotes_QuotePricedV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_LocationV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingType,
  Amwins_Orbits_Contracts_Models_v1_AddressV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_OccupancyType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_MonthsOccupiedV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ConstructionType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_FoundationType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_BasementType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevatedEnclosureType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_NumberOfStoriesV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_SquareFootageV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_YearBuiltV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_AttachedGarageType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingOverWaterType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_FinishedFirstFloorElevationV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_FloodZone,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevationHeightV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_FEMABaseFloodElevationV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevationCertificateAvailableV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_HighestFinishedGradeNextToBuildingV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_LowestOccupiedFloor,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingValuation,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationType,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ContentsValuation,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_CrawlspaceCompletionStatus,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_NumberOfStepsV1,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationRCV,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationACV,
  Amwins_Orbits_Contracts_Models_DataServices_Measurement,
  Amwins_Orbits_Contracts_Models_DataServices_UnitsOfMeasurement,
  Amwins_Orbits_Contracts_Models_v1_RiskInformation_NFIPCommunityV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_MailingAddressV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_PersonV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ConsumerCreditDisclosureV1,
  Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimType,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimAmountV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimRepairedV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ElevatedAfterPriorFloodLossV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledV1,
  Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledDateV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1,
  Amwins_Orbits_Contracts_Models_FormType,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageAV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleMode,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_MinimumDeductibleV1,
  Amwins_Orbits_Contracts_Models_Percentage,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindDeductibleType,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageBV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageCV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageDV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageEV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageFV1,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodFlex,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_RateLock,
  Amwins_Orbits_Contracts_Models_v1_CoverageInformation_RateLockLength,
  Amwins_Orbits_Contracts_MessageContracts_Quotes_PremiumBreakdown,
  Amwins_Orbits_Contracts_MessageContracts_Quotes_QuoteHeaderV1,
  Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel,
  Amwins_Orbits_Contracts_Models_ProductType,
  Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo,
  Amwins_Orbits_Contracts_MessageContracts_v2_Quotes_QuotePricedV2_System_Text_Json_JsonElement_System_Text_Json_JsonElement,
  Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2,
  Amwins_Orbits_Contracts_Models_v2_RiskModelType,
  System_Text_Json_JsonElement,
  System_Text_Json_JsonValueKind,
  Amwins_Orbits_Contracts_Models_v2_CoverageModelType,
  Amwins_Orbits_Contracts_Models_ContractVersion,
  Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor,
  Amwins_Orbits_Contracts_Models_User,
  Amwins_Orbits_Contracts_Models_UserRole,
  Amwins_Orbits_Contracts_MessageContracts_Submissions_SubmissionGatedV1,
  Amwins_Orbits_Contracts_MessageContracts_Submissions_AuthorizedSalesChannel,
  Amwins_Orbits_Contracts_Models_Producers_Broker,
  Amwins_Orbits_Contracts_Models_Producers_Retailer,
  Amwins_Orbits_Contracts_MessageContracts_Submissions_SubmissionHeaderV1,
  Amwins_Orbits_Contracts_Models_v1_Submissions_AmlinkProducerIdsV1,
  Amwins_Orbits_Contracts_MessageContracts_v2_Submissions_SubmissionGatedV2_System_Text_Json_JsonElement_System_Text_Json_JsonElement,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class DistributionService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static createDistributionSubmission(
    params: {
      /**  */
      body?: Amwins_Orbits_Contracts_Models_Distribution_DistributionSubmissionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Amwins_Orbits_Contracts_Models_Distribution_CreateSubmissionResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/submission/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDistributionSubmission(
    params: {
      /**  */
      submissionId: string;
      /**  */
      requestOrigin: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/submission/{submissionId}/{requestOrigin}';
      url = url.replace('{submissionId}', params['submissionId'] + '');
      url = url.replace('{requestOrigin}', params['requestOrigin'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetDefaultSubmissionData(
    params: {
      /**  */
      submissionId: string;
      /**  */
      salesChannel: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/submission/reset-default/{submissionId}/{salesChannel}';
      url = url.replace('{submissionId}', params['submissionId'] + '');
      url = url.replace('{salesChannel}', params['salesChannel'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUnauthorizedUsers(
    params: {
      /**  */
      getProcessed?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DistributionUnauthorizedUser[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/unauthorizedUsers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { getProcessed: params['getProcessed'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static markUnauthorizedUserAsProcessed(
    params: {
      /**  */
      body?: DistributionUnauthorizedUser;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DistributionUnauthorizedUser[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/unauthorizedUser';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static priceQuoteV1(
    params: {
      /**  */
      body?: Amwins_Orbits_Contracts_MessageContracts_Quotes_QuotePricedV1;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/PriceQuoteV1';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static priceQuoteV2(
    params: {
      /**  */
      body?: Amwins_Orbits_Contracts_MessageContracts_v2_Quotes_QuotePricedV2_System_Text_Json_JsonElement_System_Text_Json_JsonElement;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/PriceQuoteV2';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static submissionGatedV1(
    params: {
      /**  */
      body?: Amwins_Orbits_Contracts_MessageContracts_Submissions_SubmissionGatedV1;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/SubmissionGatedV1';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static submissionGatedV2(
    params: {
      /**  */
      body?: Amwins_Orbits_Contracts_MessageContracts_v2_Submissions_SubmissionGatedV2_System_Text_Json_JsonElement_System_Text_Json_JsonElement;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Distribution/SubmissionGatedV2';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
